import React from "react";
import { Badge } from "react-bootstrap";
import { formatAngka } from "../../utils";

/**
 * "Jenis chemical yang digunakan" pada daftar indikator environmental.
 *
 * Total detergent tidak menjawab pertanyaan ini: 400 ml deterjen biasa dan
 * 400 ml deterjen bersertifikat punya konsekuensi berbeda. Rinciannya berasal
 * dari kolom varian yang diisi operator saat mencatat konsumsi, bukan dari
 * indikator tersendiri.
 *
 * Baris "(tidak dicatat)" sengaja ikut ditampilkan dan ditandai. Menyembunyikan
 * pemakaian yang jenisnya kosong akan membuat tabel ini terlihat lengkap
 * padahal sebagian pemakaiannya tidak diketahui jenisnya — persis kesalahan
 * yang ingin dihindari sistem ini.
 */
function PanelChemical({ items }) {
  if (!items || items.length === 0) {
    return (
      <div className="text-muted" style={{ fontSize: "12px" }}>
        Belum ada pencatatan chemical pada periode ini.
      </div>
    );
  }

  const totalTercatat = items
    .filter((v) => v.varian !== "(tidak dicatat)")
    .reduce((t, v) => t + (Number(v.total) || 0), 0);
  const totalSemua = items.reduce((t, v) => t + (Number(v.total) || 0), 0);

  return (
    <div className="table-responsive">
      <table
        className="table table-bordered align-middle mb-0"
        style={{ fontSize: "12px" }}
      >
        <thead className="table-light">
          <tr>
            <th>Jenis chemical</th>
            <th className="text-end">Total</th>
            <th className="text-end">Pencatatan</th>
          </tr>
        </thead>
        <tbody>
          {items.map((val) => {
            const kosong = val.varian === "(tidak dicatat)";
            return (
              <tr key={val.varian}>
                <td>
                  {kosong ? (
                    <span className="text-muted fst-italic">{val.varian}</span>
                  ) : (
                    <span className="fw-bold">{val.varian}</span>
                  )}
                  {kosong ? (
                    <Badge bg="warning" text="dark" className="ms-2">
                      jenis belum diisi
                    </Badge>
                  ) : null}
                </td>
                <td className="text-end">
                  {formatAngka(val.total)}{" "}
                  <span className="text-muted">{val.unit}</span>
                </td>
                <td className="text-end">{val.log_count}x</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {totalSemua > 0 ? (
        <div className="text-muted mt-2" style={{ fontSize: "11px" }}>
          {formatAngka(Math.round((totalTercatat / totalSemua) * 100))}% pemakaian
          sudah tercatat jenisnya.
        </div>
      ) : null}
    </div>
  );
}

export default PanelChemical;
